import { isValidElement } from 'react';
import { isString } from './isString';
import { isFunction } from './isFunction';
import { isNullOrUndefined } from './isNullOrUndefined';

/**
 *  Resolve react element / string / render-prop to a renderable content
 */
const renderFuncOrElement = (o, ...funcArgs) => {
	switch (true) {
		case isNullOrUndefined(o):
			return null;
		case isString(o):
			return o;
		case isFunction(o): {
			const el = o(...funcArgs);
			if (isNullOrUndefined(el) || isString(el) || isValidElement(el)) {
				return el;
			}
			throw new Error(
				`elementOrRenderProp: invalid object returned from callback ${o.name}`,
			);
		}
		case isValidElement(o):
			return o;
		default:
			throw new Error('elementOrRenderProp: invalid object');
	}
};

export { renderFuncOrElement };
